
import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const getAlertSupplierUnconfirmedConsolidatedunreadCountSlice = createApi(`GetAlertSupplierUnconfirmedConsolidatedunreadCountSlice`,"GET");

const GetAlertSupplierUnconfirmedConsolidatedunreadCountSlice = createSlice({
  name: 'GetAlertSupplierUnconfirmedConsolidatedunreadCountSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAlertSupplierUnconfirmedConsolidatedunreadCountSlice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAlertSupplierUnconfirmedConsolidatedunreadCountSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getAlertSupplierUnconfirmedConsolidatedunreadCountSlice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default GetAlertSupplierUnconfirmedConsolidatedunreadCountSlice.reducer;